webpackJsonp([260392215011704],{

/***/ 271:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _prismicDom = __webpack_require__(10);
	
	var _rebass = __webpack_require__(4);
	
	var _components = __webpack_require__(7);
	
	var _moment = __webpack_require__(23);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Prismic = __webpack_require__(36);
	
	var linkResolver = function linkResolver(doc) {
	  return "/" + doc.type;
	};
	
	var Institution = function (_React$Component) {
	  _inherits(Institution, _React$Component);
	
	  function Institution() {
	    _classCallCheck(this, Institution);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Institution.prototype.componentDidMount = function componentDidMount() {
	    if (this.props.data.page.alternate_languages) {
	      this.context.setAltLanguages(this.props.data.page.alternate_languages);
	    } else {
	      this.context.setAltLanguages(undefined);
	    }
	  };
	
	  Institution.prototype.render = function render() {
	    var _this2 = this;
	
	    var json = undefined;
	    if (this.props.data.page.raw) {
	      json = JSON.parse(this.props.data.page.raw);
	    }
	    var showInactive = false;
	    if (this.props.data.institutionProjects) {
	      this.props.data.institutionProjects.edges.forEach(function (edge) {
	        if (edge.node.data.status === "Inactive" || edge.node.data.status === "Canceled" || edge.node.data.status === "Archived") {
	          showInactive = true;
	        }
	      });
	    }
	    if (this.props.data.institutionProjects2) {
	      this.props.data.institutionProjects2.edges.forEach(function (edge) {
	        if (edge.node.data.status === "Inactive" || edge.node.data.status === "Canceled" || edge.node.data.status === "Archived") {
	          showInactive = true;
	        }
	      });
	    }
	    if (this.props.data.institutionProjects3) {
	      this.props.data.institutionProjects3.edges.forEach(function (edge) {
	        if (edge.node.data.status === "Inactive" || edge.node.data.status === "Canceled" || edge.node.data.status === "Archived") {
	          showInactive = true;
	        }
	      });
	    }
	    return _react2.default.createElement(
	      "div",
	      {
	        style: this.props.transition ? this.props.transition.style : { opacity: 0 }
	      },
	      _react2.default.createElement(_components.Head, {
	        source: {
	          meta_title: [{
	            text: json.data.title !== undefined ? json.data.title[0] ? json.data.title[0].text + " | Bank Information Center" : "" : ""
	          }],
	          meta_description: [{
	            text: json.data.description !== undefined ? json.data.description[0] ? json.data.description[0].text : "" : ""
	          }],
	          social_sharing_image: {
	            url: json.data.header_image !== undefined ? json.data.header_image.url : ""
	          }
	        }
	      }),
	      _react2.default.createElement(
	        _components.Main,
	        null,
	        _react2.default.createElement(
	          _components.PageHeader,
	          { title: json.data.title[0].text, color: json.uid },
	          json.data.subtitle[0] && _react2.default.createElement(_components.H2, { children: json.data.subtitle[0].text, fontSize: [4, 5] }),
	          json.data.description[0] && _react2.default.createElement(_components.Article, {
	            dangerouslySetInnerHTML: {
	              __html: _prismicDom.RichText.asHtml(json.data.description, linkResolver)
	            }
	          })
	        ),
	        _react2.default.createElement(
	          _components.PageSection,
	          null,
	          _react2.default.createElement(
	            _components.PageContent,
	            null,
	            json.data.body1.length > 0 && _react2.default.createElement(
	              "div",
	              null,
	              json.data.body1.map(function (callout, index) {
	                return _react2.default.createElement(
	                  _rebass.Box,
	                  { mt: 3 },
	                  _react2.default.createElement(
	                    _components.GradientCard,
	                    { key: "gradientCard" + index },
	                    _react2.default.createElement(
	                      _rebass.Box,
	                      { w: [1, null, 1 / 2] },
	                      callout.primary.small_heading[0] && _react2.default.createElement(_components.H4, {
	                        children: callout.primary.small_heading[0].text,
	                        mb: 5
	                      }),
	                      callout.primary.callout[0] && _react2.default.createElement(_components.H2, {
	                        children: callout.primary.callout[0].text,
	                        mb: 5,
	                        fontSize: [4, 5]
	                      }),
	                      callout.primary.subtext[0] && _react2.default.createElement(_components.Text, {
	                        children: callout.primary.subtext[0].text,
	                        fontSize: [2, 3],
	                        mb: 5
	                      }),
	                      callout.primary.button_text && _react2.default.createElement(_components.PrimaryButton, {
	                        children: callout.primary.button_text,
	                        is: callout.primary.button_file.url ? "a" : callout.primary.button_link ? callout.primary.button_link.indexOf("http") !== -1 || callout.primary.button_link.indexOf("mailto") !== -1 ? "a" : _gatsbyLink2.default : _gatsbyLink2.default,
	                        to: "/" + _this2.props.data.page.lang + "/" + callout.primary.button_link,
	                        href: callout.primary.button_link ? callout.primary.button_link : callout.primary.button_file ? callout.primary.button_file.url : ""
	                      })
	                    )
	                  )
	                );
	              })
	            )
	          )
	        ),
	        (this.props.data.institutionProjects || this.props.data.institution2Projects || this.props.data.institution3Projects) && _react2.default.createElement(
	          _components.PageSection,
	          null,
	          _react2.default.createElement(
	            _components.PageContent,
	            null,
	            _react2.default.createElement(_components.H2, {
	              children: json.lang === "en-us" ? "Ongoing Projects" : json.lang === "es-mx" ? "Proyectos en curso" : "مشاريع جارية",
	              mb: 5
	            }),
	            _react2.default.createElement(
	              _components.CardLayout,
	              null,
	              [].concat(this.props.data.institutionProjects ? this.props.data.institutionProjects.edges : [], this.props.data.institution2Projects ? this.props.data.institution2Projects.edges : [], this.props.data.institution3Projects ? this.props.data.institution3Projects.edges : []).map(function (project, index) {
	                if (project.node.data.status === "Active" || project.node.data.status === "Approved" || project.node.data.status === "Proposed") {
	                  return _react2.default.createElement(_components.Card, { key: "project" + index, object: project.node });
	                } else {
	                  return null;
	                }
	              })
	            )
	          )
	        ),
	        (this.props.data.institutionUpdates || this.props.data.institution2Updates || this.props.data.institution3Updates) && _react2.default.createElement(
	          _components.PageSection,
	          { column: "true", borderTop: "true" },
	          _react2.default.createElement(_components.H2, {
	            children: json.lang === "en-us" ? "Related Updates" : json.lang === "es-mx" ? "Noticias" : "التحديثات ذات الصلة",
	            mb: 5,
	            fontSize: [4, 5]
	          }),
	          _react2.default.createElement(
	            _components.CardLayout,
	            { w: 1 / 1 },
	            [].concat(this.props.data.institutionUpdates ? this.props.data.institutionUpdates.edges : [], this.props.data.institution2Updates ? this.props.data.institution2Updates.edges : [], this.props.data.institution3Updates ? this.props.data.institution3Updates.edges : []).sort(function (a, b) {
	              if ((0, _moment2.default)(a.node.data.publish_date).utc() < (0, _moment2.default)(b.node.data.publish_date).utc()) return 1;
	              if ((0, _moment2.default)(a.node.data.publish_date).utc() > (0, _moment2.default)(b.node.data.publish_date).utc()) return -1;
	              return 0;
	            }).slice(0, 4).map(function (update, index) {
	              return _react2.default.createElement(_components.UpdateCard, { key: "project" + index, object: update.node });
	            })
	          ),
	          _react2.default.createElement(
	            _rebass.Flex,
	            { width: "100%", justify: "center" },
	            _react2.default.createElement(
	              _rebass.Box,
	              { pt: 6 },
	              _react2.default.createElement(_components.PrimaryButton, {
	                mt: 3,
	                children: json.lang === "en-us" ? "View More" : json.lang === "es-mx" ? "Más noticias" : "عرض المزيد",
	                is: _gatsbyLink2.default,
	                to: "/" + this.props.data.page.lang + "/updates/?institution=" + this.props.data.page.prismicId,
	                "aria-label": "View more updates"
	              })
	            )
	          )
	        ),
	        (this.props.data.institutionResources || this.props.data.institution2Resources || this.props.data.institution3Resources) && _react2.default.createElement(
	          _components.PageSection,
	          { column: "true", borderTop: "true" },
	          _react2.default.createElement(_components.H2, {
	            children: json.lang === "en-us" ? "Related Resources" : json.lang === "es-mx" ? "Otros recursos" : "موارد ذات الصلة",
	            mb: 5,
	            fontSize: [4, 5]
	          }),
	          _react2.default.createElement(
	            _components.CardLayout,
	            { w: 1 / 1 },
	            [].concat(this.props.data.institutionResources ? this.props.data.institutionResources.edges : [], this.props.data.institution2Resources ? this.props.data.institution2Resources.edges : [], this.props.data.institution3Resources ? this.props.data.institution3Resources.edges : []).sort().slice(0, 8).map(function (resource, index) {
	              return _react2.default.createElement(_components.ResourceCard, {
	                key: "resource" + index,
	                object: resource.node
	              });
	            })
	          ),
	          _react2.default.createElement(
	            _rebass.Flex,
	            { width: "100%", justify: "center" },
	            _react2.default.createElement(
	              _rebass.Box,
	              { pt: 6 },
	              _react2.default.createElement(_components.PrimaryButton, {
	                children: json.lang === "en-us" ? "View More" : json.lang === "es-mx" ? "Más noticias" : "عرض المزيد",
	                is: _gatsbyLink2.default,
	                to: "/" + json.lang + "/resources/?institution=" + this.props.data.page.prismicId,
	                "aria-label": "View more resources"
	              })
	            )
	          )
	        ),
	        showInactive && _react2.default.createElement(
	          _components.PageSection,
	          { column: "true", borderTop: "true" },
	          _react2.default.createElement(
	            _components.PageContent,
	            null,
	            _react2.default.createElement(
	              _rebass.Box,
	              null,
	              _react2.default.createElement(_components.H2, {
	                children: json.lang === "en-us" ? "Inactive Projects" : json.lang === "es-mx" ? "Proyectos inactivos" : "مشاريع غير نشطة",
	                mb: 5
	              }),
	              _react2.default.createElement(
	                _components.CardLayout,
	                null,
	                [].concat(this.props.data.institutionProjects ? this.props.data.institutionProjects.edges : [], this.props.data.institution2Projects ? this.props.data.institution2Projects.edges : [], this.props.data.institution3Projects ? this.props.data.institution3Projects.edges : []).map(function (project, index) {
	                  if (project.node.data.status === "Inactive" || project.node.data.status === "Canceled" || project.node.data.status === "Archived") {
	                    return _react2.default.createElement(_components.Card, { key: "project" + index, object: project.node });
	                  } else {
	                    return null;
	                  }
	                })
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Institution;
	}(_react2.default.Component);
	
	Institution.contextTypes = {
	  setAltLanguages: _propTypes2.default.func
	};
	exports.default = Institution;
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-institution-js-b6aff22c3d1736a8be58.js